import React, { Component } from 'react';
import './lammie-guidance.css';

export default class LammieGuidance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            lammieGuidance: {}
        };
    }

    componentDidMount() {
        this.getLammieGuidance();
    }

    render() {
        return this.state.loading
            ? (
                <div>
                    <p>Loading...</p>
                </div>
            )
            : (
                <div className="guidance-container">
                    <h1>Lammie Guidance</h1>
                    <div>
                        <a href="https://sites.google.com/view/ref-site/crafting/shelves-of-power">Link to the ref site</a>
                    </div>
                    <h2>{this.state.lammieGuidance.generalGuidanceTitle}</h2>
                    <ul>
                        {this.state.lammieGuidance.generalGuidance.map(guidance =>
                            <li>{guidance}</li>
                        )}
                    </ul>
                    <h2>{this.state.lammieGuidance.lowShelfPowersTitle}</h2>
                    <ul>
                        {this.state.lammieGuidance.lowShelfPowers.map(power =>
                            <li>{power}</li>
                        )}
                    </ul>
                    <h2>{this.state.lammieGuidance.mediumShelfPowersTitle}</h2>
                    <ul>
                        {this.state.lammieGuidance.mediumShelfPowers.map(power =>
                            <li>{power}</li>
                        )}
                    </ul>
                    <h2>{this.state.lammieGuidance.highShelfPowersTitle}</h2>
                    <ul>
                        {this.state.lammieGuidance.highShelfPowers.map(power =>
                            <li>{power}</li>
                        )}
                    </ul>
                    <h2>{this.state.lammieGuidance.additionalGuidanceTitle}</h2>
                    <ul>
                        {this.state.lammieGuidance.additionalGuidance.map(guidance =>
                            <li>{guidance}</li>
                        )}
                    </ul>
                    <h2>{this.state.lammieGuidance.exampleWordingsTitle}</h2>
                    <ul>
                        {this.state.lammieGuidance.exampleWordings.map(wording =>
                            <li>{wording}</li>
                        )}
                    </ul>
                </div>
            )
    }

    async getLammieGuidance() {
        const response = await fetch("lammie/getlammieguidance");
        const data = await response.json();
        this.setState({ lammieGuidance: data, loading: false });
    }
}
